import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    list: {
        listStyle: 'square',
    },
    formLabelBlock: {
        display: 'block',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    readOnly: {
        '& fieldset': {
            borderColor: '#000000 !important',
            borderWidth: '1px !important',
        },
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#eeeeee !important',
            caretColor: 'transparent',
        },
        '& .MuiInputBase-inputMultiline': {
            textAlign: 'justify',
        }
    },
    longLabelText: {
        alignItems: 'center',
        '& .MuiFormLabel-root': {
            marginTop: '0 !important',
            whiteSpace: 'normal !important'
        }
    },
}))

export default useStyles
